"use client";

import type { ReactNode } from "react";
import { openConsentSettings } from "@/lib/consent";

/** Re-opens the cookie notice so a visitor can change their choice. Used in the footer and the Cookie Policy. */
export function CookieSettingsButton({ className, children }: { className?: string; children?: ReactNode }) {
  return (
    <button type="button" className={className} onClick={openConsentSettings}>
      {children ?? "Cookie settings"}
    </button>
  );
}
